import React from 'react';
import { Address } from 'shared-client/types/address';
import { Localizer } from 'services/Localizer';

interface FormattedAddressProps {
	address: Address;
	recipientName?: string;
	displayCountry?: boolean;
	displayPhone?: boolean;
	//#region Commerce
	shipToName?: string;
	isOrganizationAddress?: boolean;
	//#endregion Commerce
}

export default function FormattedAddress(props: FormattedAddressProps) {
	const {
		address,
		recipientName,
		displayCountry = false,
		displayPhone = false,
		//#region Commerce
		shipToName,
		isOrganizationAddress = false,
		//#endregion Commerce
	} = props;

	return (
		<div className="roc-card-list__item-user-details">
			<p>
				{
					//#region Commerce
				}
				{/* Organizations */}
				{shipToName ? (
					<>
						<strong>{shipToName} </strong>
						<br />
					</>
				) : null}
				{
					//#endregion Commerce
				}
				{recipientName ? (
					<>
						{recipientName}
						<br />
					</>
				) : null}

				{/* Name */}
				{
					//#region Commerce
				}
				{!isOrganizationAddress ? (
					<>
						{
							//#endregion Commerce
						}
						{address.prefix ? address.prefix + ' ' : null}
						{address.firstName ? address.firstName : null}
						{address.middleInitial ? ' ' + address.middleInitial : null}
						{address.lastName ? ' ' + address.lastName : null}
						{address.suffix ? ' ' + address.suffix : null}
						{address.company ? (
							<>
								<br />
								{address.company}
							</>
						) : null}
						<br />
						{
							//#region Commerce
						}
					</>
				) : null}
				{
					//#endregion Commerce
				}

				{/* Street */}
				{/* #region HCL */}
				{address.address1 ? <>{address.address1 !== '.' ? address.address1 + ', ' : null}</> : null}
				{address.address2 ? <>{address.address2 !== '.' ? address.address2 + ', ' : null}</> : null}
				{/* #endregion */}
				{/* City, State, Zip */}
				{address.city}
				{address.country === 'US' || address.country === 'CA'
					? address.state
						? ', ' + address.state
						: null
					: address.region
					? ', ' + address.region
					: null}
				{address.postalCode ? ' ' + address.postalCode : null}
			</p>
			{displayCountry ? <p>{address.country}</p> : null}
			{displayPhone ? (
				<p>
					{Localizer('FormattedAddressPhone')} {address.phone}
				</p>
			) : null}
		</div>
	);
}
